import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <div className="container">
        {/* Hero Section */}
        <section className="about-hero">
          <div className="hero-content">
            <h1>About Oromo Gadaa-UK</h1>
            <p>Preserving our rich cultural heritage while building bridges in the United Kingdom</p>
          </div>
          <div className="hero-image">
            <img src="/Images/walgeeti_1.png" alt="Gadaa Community" />
          </div>
        </section>

        {/* About Content */}
        <section className="about-content">
          <div className="content-grid">
            <div className="content-section">
              <h2>Our Heritage</h2>
              <p>
                The Gadaa system is a traditional democratic system of governance used by the Oromo people of Ethiopia and Kenya. 
                It is a complex system of social organization that has guided Oromo society for centuries, emphasizing equality, 
                responsibility, and peaceful conflict resolution.
              </p>
              <p>
                Our community in the UK carries forward these timeless values, adapting them to our modern context while 
                maintaining their essential spirit of unity, justice, and collective responsibility.
              </p>
            </div>

            <div className="content-section">
              <h2>Our Mission</h2>
              <p>
                To preserve, promote, and practice the Gadaa cultural values within the Oromo community in the United Kingdom, 
                while fostering integration and mutual understanding with the broader British society.
              </p>
              <ul>
                <li>Preserve Oromo language and cultural traditions</li>
                <li>Support community members in their integration journey</li>
                <li>Educate younger generations about their heritage</li>
                <li>Build bridges with other communities in the UK</li>
                <li>Promote the democratic values of the Gadaa system</li>
              </ul>
            </div>

            <div className="content-section">
              <h2>Our Vision</h2>
              <p>
                A thriving Oromo community in the UK that successfully balances cultural preservation with modern integration, 
                contributing positively to British society while maintaining strong connections to our ancestral heritage.
              </p>
            </div>

            <div className="content-section">
              <h2>Community Values</h2>
              <div className="values-grid">
                <div className="value-item">
                  <h3>Safuu (Ethics)</h3>
                  <p>Maintaining moral integrity and ethical conduct in all our interactions</p>
                </div>
                <div className="value-item">
                  <h3>Nagaa (Peace)</h3>
                  <p>Promoting peace, harmony, and conflict resolution within our community</p>
                </div>
                <div className="value-item">
                  <h3>Walabummaa (Freedom)</h3>
                  <p>Respecting individual freedom while maintaining collective responsibility</p>
                </div>
                <div className="value-item">
                  <h3>Tokkummaa (Unity)</h3>
                  <p>Building unity and solidarity among all community members</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Leadership Section */}
        <section className="leadership">
          <h2>Our Leadership</h2>
          <p>
            Our community is guided by elected leaders who follow the traditional Gadaa principles of 
            democratic governance, transparency, and accountability. Leadership roles rotate regularly 
            to ensure broad participation and prevent concentration of power.
          </p>
          <div className="leadership-structure">
            <div className="leadership-item">
              <h3>Abbaa Gadaa (President)</h3>
              <p>The elected leader who guides the community and represents us in external affairs</p>
            </div>
            <div className="leadership-item">
              <h3>Council of Elders</h3>
              <p>Experienced community members who provide wisdom and guidance on important matters</p>
            </div>
            <div className="leadership-item">
              <h3>Youth Representatives</h3>
              <p>Young community members who ensure the voice of the next generation is heard</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
